import { Navbar } from "reactstrap";
import styled from "styled-components";

const HeaderNavbar = styled(Navbar)`
  background-color: #FFFFFF;
  border-bottom: 1px solid #CCCCCC;
  padding: 0.75rem 1rem;
  @media (min-width: 992px) {
    padding: 0.75rem 2.5rem;
  }
`;


export default HeaderNavbar;
